import { render, staticRenderFns } from "./FlowPaymentInfoView.vue?vue&type=template&id=62b7da83&scoped=true&"
import script from "./FlowPaymentInfoView.vue?vue&type=script&lang=ts&"
export * from "./FlowPaymentInfoView.vue?vue&type=script&lang=ts&"
import style0 from "./FlowPaymentInfoView.vue?vue&type=style&index=0&id=62b7da83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b7da83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDivider,VExpandTransition,VIcon,VRow,VSwitch,VTimeline,VTimelineItem})
